// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__14vxN","label":"CategoryService_label__1_ecT","location":"CategoryService_location__1s5aM"};